<template>
    <div v-if="club != null">
        <div class="g_menuDesktop" style="height: 150px">
        
         <div style="margin-left: 10px">
            <s-button icon="users" theme="is-primary" label="Revenir aux membres" @onclick="listMembres"/> 
        </div>
        <div class="title is-4" style="padding-left:40px;margin-top: 10px"  >
            <s-l id="allDemandes" :v="club.name">Liste des demandes d'adhésion pour le club %v</s-l>
        </div>
        <div style="padding-left:20px;">
             <s-switch id="smail" @change="status=!status" :defaultState="status" labelEnableText="Demande rejetée" labelDisableText="Demande en cours"/>
        </div>
        </div>
        <div class="g_menuMobile" >
        <table class="g_menuFooterMin">
            <tr>
                <td colspan="5" class="g_headerFooter" >
                </td>
            </tr>
            <tr>
                <td >
                    <s-button  icon="list" @onclick="listMembres" theme="is-warning" label="Retour" mode="V" />
                </td>
                <td  colspan="4" style="vertical-align:middle">
                   <s-switch id="smail" @change="status=!status" :defaultState="status" labelEnableText="Demandes rejetées" labelDisableText="Demandes en cours"/>
                </td>
            </tr>
        </table>
        </div>
        <div v-for="demande in demandes" class="list" v-show="filterByStatus(demande)">
            <div class="ligne">
            <div class="info">
                <b>{{demande.demandes[club.id].nom}} {{demande.demandes[club.id].prenom}}</b>    
            </div>
            <div >
                {{demande.email}}
            </div>
            <div v-if="!status">
                <div class="buttons">
                    <s-button icon="user-plus" theme="is-success" mode="V" label="Ajouter aux membres" @onclick="openModalAdd(demande)"/>
                </div>
                <div class="buttons">
                    <s-button icon="user-check" theme="is-primary" mode="V" label="Fusionner avec un membre" 
                        @onclick="openModalFusion(demande)"/>
                </div>
                <div class="buttons">    
                    <s-button icon="ban" theme="is-danger" mode="V" label="Refuser la demande" @onclick="openModalRefus(demande)"/>    
                </div>
            </div>
           <div v-if="status">
                <div class="buttons"> 
                    <s-button icon="ban" theme="is-danger" mode="V" label="Supprimer définivement la demande" @onclick="openModalSupprimer(demande)"/>    
                 </div>
                 <div class="buttons"> 
                    <s-button icon="check" theme="is-success" mode="V" label="Réactiver la demande" @onclick="reactiver(demande)"/>    
                 </div>
                 
            </div>
            </div>
        </div>
        <div v-if="demandes.length==0" class="listNotFound">
           <b> Aucune demande d'adhésion</b>
        </div>
        <s-confirm
            :open="modalRefus"
            @no="modalRefus=false"
            @yes="refus"
        >
            <s-l id="confirm_refus">Etes vous sûr de refuser sa demande d'adhésion ?<br/>Un mail lui sera envoyé pour le notifier de votre refus</s-l>
            <s-l id="textRefus">Vous pouvez peut être lui adresser quelques mots expliquer la raison de votre refus (ce sera transmis par mail):</s-l>
            <div>
            <textarea v-model="motivationRefus" cols="80" rows="3" maxlength="200" placeholder="Raison du refus (facultatif)"/>
            </div>
            <div>
                <s-l id="refus_archive">La demande sera mis archivée. Vous pourrez toujours revenir dessus. L'utilisateur ne pourra plus jamais en refaire la demande (avec cet email) tant que vous la laissez "dans archivé"</s-l>
            </div>
        </s-confirm>
        <s-confirm
            :open="modalAdd"
            @no="modalAdd=false"
            @yes="add"
        >
            <s-l id="confirm_add_adhesion">Etes vous sûr d'ajouter cet utilisateur à vos membres ?</s-l>
            
        </s-confirm>
        <s-confirm
            :open="confirmModalFusion"
            @no="confirmModalFusion=false"
            @yes="fusion"
        >
            <div v-if="membreAFusionner">
            <s-l id="confirmModalFusion" :v="membreAFusionner.nom + ' '+membreAFusionner.prenom">Vous êtes sur le point de fusionner le membre %v avec le joueur qui a fait la demande d'adhésion </s-l>
            <s-l id="confirmModalFusion1">Veuillez confirmer ?<br/>(le nom, le prénom et l'email seront remplacés)</s-l>
            </div>
        </s-confirm>
        <s-modal
            title="Liste des membres :"
            :open="modalFusion"
            @close="modalFusion=false"
            :close="true"
        >
           
                 <div style="text-align:right;height: 30px;">
                    <s-switch id="smail" @change="withOutEmail=!withOutEmail" :defaultState="withOutEmail" labelEnableText="Sans Email" labelDisableText="Email ou sans email"/>
                </div>

                <s-input-search placeholder="nom ou prénom" width="270px"  theme="is-primary" themeEraser="is-warning" v-model="search"/>
             <div class="listAllMembres">
                <div v-for="membre in membres" v-show="filterBy(membre)" class="listAllMembre">
                   {{membre.nom}} {{membre.prenom}} 
                    <div style="float:right;vertical-align:top" class="g_desktopOn">
                    <s-button icon="people-arrows" label="fusionner" theme="is-primary is-small" @onclick="openConfirmModalFusion(membre)"
                        :disabled="membre.email!=''"/>
                        
                   </div>
                    <div style="float:right;vertical-align:top" class="g_mobileOn">
                            <s-button icon="people-arrows" label="" 
                             :disabled="membre.email!=''"
                            theme="is-primary is-small"  @onclick="openConfirmModalFusion(membre)"/>
                   </div>
                   <div style="" v-show="membre.email!=''">
                       {{membre.email}}
                   </div>
                   
                </div>
            </div>
        </s-modal>
        <s-modal
            title="Email existe déjà"
            :open="modalErrorAdd"
            :close="true"
            @close="modalErrorAdd=false"
        >
            <s-l id="modalErrorADHESIONAdd">Un de vos membres a déjà cet email</s-l>

        </s-modal>
        <s-modal
            title="Demande acceptée"
            :open="modalDemandeAccepte"
            :close="true"
            @close="modalDemandeAccepte=false"
        >
            <s-l id="modalDemandeAccepte">La demande a été acceptée, le joueur va recevoir un email, il pourra se connecter au club</s-l>

        </s-modal>
        <s-confirm
            title="Demande supprimer"
            :open="modalSupprimer"
            @no="modalSupprimer = false"
            @yes="supprimerDemande()"
            >
            <s-l id="modalSupprimer">Vous êtes sur le point de supprimer la demande<br/> L'utilisateur pourra vous demander de nouveau d'adhérer à votre club</br>Cliquez sur Oui pour confirmer</br></s-l>
        </s-confirm>
    </div>
</template>
<style scoped>
    .listAllMembre {
        padding: 6px;
        margin: 5px;
        border: thin solid black;
        height: 60px;
    }
    .listAllMembres {
        overflow-y: auto;
        height: 320px;
    }
    .listNotFound {
         margin-left: 40px;
        color: black;
        font-size: 20px;
    }
    .info {
       
    }
    .buttons {
        display: inline-block;
        margin-left: 10px;
        margin-top: 30px;
        width: 100px;
    }
    .list {
        margin-left: 10px;
        color: black;
    }
    .list div.ligne {
        border: thin solid black;
        padding: 10px;
        margin-top: 20px;
        display: inline-block;
    }
    
</style>
<script>
import firebase_api from "@/firebase/firebase_api"

import club_fct from "@/firebase/club"
import joueur_fct from "@/firebase/joueur"
export default {
    data() {
        return {
            configMembreModal: false,
            importClient: false,
            club: null,
            demandes: [],
            modalRefus: false,
            modalAdd: false,
            modalFusion: false,
            modalSupprimer: false,
            demande: null,
            motivationRefus: "",
            membres: [],
            search: "",
            withOutEmail: false,
            confirmModalFusion: false,
            membreAFusionner: null,
            modalErrorAdd: false,
            modalDemandeAccepte: false,
            status: false
        }
    },
    methods: {
        openModalSupprimer(demande) {
            this.modalSupprimer = true;
            this.demande = demande;
        },
        reactiver(demande) {
            firebase_api.api.getDb().collection("club").doc(this.club.id).collection("demandes").doc(demande.id)
                .update ({
                    status : null
                })
        },
        filterByStatus(demande) {
            if(!this.status)
                return demande.status == null;
            else
                return demande.status == false;
        },
        filterBy(membre) {
            
            var filterNom = true;
            var filterEmail = true;
            var filterPrenom = true;
            filterNom = membre.nom.substring(0, this.search.length).toUpperCase() == this.search.toUpperCase();
            filterPrenom = membre.prenom.substring(0, this.search.length).toUpperCase() == this.search.toUpperCase();
            
            if (this.withOutEmail)
                filterEmail = membre.email == '';
            return (filterNom  || filterPrenom) && filterEmail;
        },
        listMembres() {
             this.$router.push({name: "membres", params: {id: this.club.id}})
        },
        openConfirmModalFusion(membreAFusionner) {
            this.membreAFusionner = membreAFusionner;
            this.confirmModalFusion=true;
            this.modalFusion=false;
        },
        openModalAdd(demande) {
            this.demande = demande;
            this.modalAdd=true;
        },
        openModalRefus(demande) {
            this.demande = demande;
            this.modalRefus=true;
        },
        async openModalFusion(demande) {
            this.demande = demande;
            if (this.membres.length==0) {
                var joueursRef = firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("joueurs")
                var joueursDoc = await joueursRef.get();
               
                for (var indexJoueur in joueursDoc.docs) {
                    var joueurDoc = joueursDoc.docs[indexJoueur];
                    var joueurData = joueurDoc.data();
                    this.membres.push(joueurData);
                }
                this.membres.forEach(joueur=>{
                        joueur.nomMAJ = joueur.nom.toUpperCase();
                })
                this.membres.sort((a,b)=> {
                        return a.nomMAJ.localeCompare(b.nomMAJ,'fr', {ignorePunctuation: true})
                })
                this.search = demande.demandes[this.club.id].nom;
                this.modalFusion = true;
            }
            else {
                this.search = demande.demandes[this.club.id].nom;
                this.modalFusion = true;
            }
            
        },
        refus() {
            club_fct.object.refusDemande(this.club, this.demande);
            this.modalRefus=false;
        },
        async add(idJoueur) {
             this.modalAdd = false;
            var batch = firebase_api.api.getDb().batch();
            var joueurData = JSON.parse(JSON.stringify(joueur_fct.object.data));
            joueurData.nom = this.demande.demandes[this.club.id].nom.toUpperCase();
            joueurData.prenom = this.demande.demandes[this.club.id].prenom;
            joueurData.pseudo = this.demande.demandes[this.club.id].prenom;
            if (typeof(idJoueur)!="undefined")
                joueurData.id = idJoueur;
            var pseudo = '';
            if (joueurData.nom!='') {
              var pseudo = joueurData.nom.substr(0,7).toUpperCase();
              if (joueurData.prenom!='')
                  pseudo += "." + joueurData.prenom.substr(0,3).toUpperCase();
              else
                   pseudo += joueurData.nom.substr(8,3).toUpperCase();
              }
              else {
                  if (joueurData.prenom!='')
                    pseudo += joueurData.prenom.substr(0,11).toUpperCase();
                  else
                    pseudo = new Date().getTime().toString().substr(0,11).toUpperCase();
              }
            joueurData.pseudo = pseudo;
            joueurData.email = this.demande.id;
            club_fct.object.addJoueur(this.club, joueurData, batch, null, (add)=>{
                if (typeof(add.error)!="undefined") {
                    this.modalErrorAdd = true;
                }
                else {
                    batch.commit();
                    this.modalDemandeAccepte = true;
                    this.supprimerDemande();
                }
                
               

            })
        },
        fusion() {
            this.add(this.membreAFusionner.id);
            this.confirmModalFusion=false;
        },
        supprimerDemande() {
            club_fct.object.supprimerDemande(this.club, this.demande);
            this.modalSupprimer=false;

        }
        
    },
    mounted() {
        var idClub = this.$route.params.id;
        this.$bind("club", firebase_api.api.getDb().collection('club').doc(idClub))
        this.$bind("demandes", firebase_api.api.getDb().collection('club').doc(idClub).collection("demandes"))
    },
}
</script>